import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';
import { CakeItEasyWebUiModule } from '@cakeiteasy/web-ui';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgBusyModule } from 'ng-busy';

import { directives } from './directives';

import { UiLocationSearchBarComponent } from './components/ui-location-search-bar/ui-location-search-bar.component';
import { UiJsonLdComponent } from './components/ui-json-ld/ui-json-ld.component';
import { UiActionResultComponent } from './components/ui-action-result/ui-action-result.component';
import { HowItWorksComponent } from './components/how-it-works/how-it-works.component';
import { BenefitsComponent } from './components/benefits/benefits.component';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import { UserDropdownMenuComponent } from './components/user-dropdown-menu/user-dropdown-menu.component';
import { HeaderMobileMenuComponent } from './components/header-mobile-menu/header-mobile-menu.component';
import { HeaderCartComponent } from './header-cart/header-cart.component';
import { UpsSectionComponent } from './components/ups-section/ups-section.component';
import { FooterLayoutComponent } from './components/footer-layout/footer-layout.component';
import { CountrySelectorComponent } from '@ui/components/country-selector/country-selector.component';
import { GiftCardsBannerHomeComponent } from './components/gift-cards-banner-home/gift-cards-banner-home.component';
import { GiftCardsBannerReceiptComponent } from './components/gift-cards-banner-receipt/gift-cards-banner-receipt.component';
import { UiMobileButtonsSkeletonComponent } from './components/ui-mobile-buttons-skeleton/ui-mobile-buttons-skeleton.component';
import { LanguageSelectorDropdownComponent } from './components/language-selector-dropdown/language-selector-dropdown.component';

const COMPONENTS = [
  UiLocationSearchBarComponent,
  UiJsonLdComponent,
  UiActionResultComponent,
  HowItWorksComponent,
  BenefitsComponent,
  LanguageSelectorComponent,
  UserDropdownMenuComponent,

  HeaderMobileMenuComponent,
  HeaderCartComponent,
  UpsSectionComponent,
  CountrySelectorComponent,
  FooterLayoutComponent,
  GiftCardsBannerHomeComponent,
  GiftCardsBannerReceiptComponent,
  UiMobileButtonsSkeletonComponent,
  LanguageSelectorDropdownComponent,
];

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CommonModule,
    NgbModule,
    NgCakeItEasyUtilsModule,
    TranslateModule,
    NgBusyModule,
    CakeItEasyWebUiModule,
  ],
  declarations: [
    ...COMPONENTS,
    ...directives,
  ],
  exports: [
    ...COMPONENTS,
    ...directives,
  ]
})
export class UiModule {
}

